import { useQuery } from "@tanstack/react-query";
import { client } from "@/lib/hono";
import type { AvatarWithLooks } from "../types";

export const useGetAvatar = (id: string | undefined) => {
    return useQuery<AvatarWithLooks | null>({
        queryKey: ["avatar", id],
        queryFn: async () => {
            if (!id) return null;
            const response = await client.api.avatars.heygen.avatars[":id"].$get({
                param: { id },
            });
            if (!response.ok) throw new Error("Failed to load avatar");
            const json = await response.json();
            return json.data.avatar as AvatarWithLooks;
        },
        enabled: !!id,
    });
};
